export default "__VITE_ASSET__CNwgwFsC__"